export default {
  en: {
    notFoundTitle: 'Conversation not found',
    notFoundMessage: 'This link leads to someone else’s conversation, or it has been deleted.',
    back: 'Go back',
    closedMessage: 'Please try again later.',
    writeSupport: 'Contact support',
    preparingTutor: 'Preparing your tutor',
    micUnavailable: 'Microphone unavailable — type your answer instead',
    micDenied: 'The microphone is unavailable because you denied access to it. Reopen the app or use the keyboard',
    micSilent: 'The microphone recorded silence — try again',
    micStartFailed: "Couldn't start recording — tap again ({{reason}})",
    backToVoice: 'Back to voice',
    typePlaceholder_en: 'Write your reply in English',
    typePlaceholder_de: 'Write your reply in German',
    typePlaceholder_pt: 'Write your reply in Portuguese',
    yourMessage: 'Your message',
    send: 'Send',
    typeText: 'Type instead',
    deleteRecording: 'Delete recording',
    thinking: 'Thinking',
    turnFailed: "I couldn't answer — try again",
    turnOffline: 'No connection — check your internet and try again',
  },
  ru: {
    notFoundTitle: 'Разговор не найден',
    notFoundMessage: 'Ссылка ведёт в чужой разговор или он был удалён.',
    back: 'Вернуться',
    closedMessage: 'Попробуйте зайти позже.',
    writeSupport: 'Написать в поддержку',
    preparingTutor: 'Готовим собеседника',
    micUnavailable: 'Микрофон недоступен — набери ответ текстом',
    micDenied: 'Микрофон недоступен, потому что Вы запретили к нему доступ. Перезайдите или воспользуйтесь клавиатурой',
    micSilent: 'Микрофон записал тишину — попробуй ещё раз',
    micStartFailed: 'Не получилось начать запись — нажми ещё раз ({{reason}})',
    backToVoice: 'Вернуться к голосу',
    typePlaceholder_en: 'Напиши ответ по-английски',
    typePlaceholder_de: 'Напиши ответ по-немецки',
    typePlaceholder_pt: 'Напиши ответ по-португальски',
    yourMessage: 'Твоя реплика',
    send: 'Отправить',
    typeText: 'Ввести текстом',
    deleteRecording: 'Удалить запись',
    thinking: 'Думаю',
    turnFailed: 'Не получилось ответить — попробуй ещё раз',
    turnOffline: 'Нет связи — проверь интернет и попробуй ещё раз',
  },
  de: {
    notFoundTitle: 'Gespräch nicht gefunden',
    notFoundMessage: 'Dieser Link führt zum Gespräch einer anderen Person, oder es wurde gelöscht.',
    back: 'Zurück',
    closedMessage: 'Bitte versuche es später noch einmal.',
    writeSupport: 'Support kontaktieren',
    preparingTutor: 'Wir bereiten deinen Tutor vor',
    micUnavailable: 'Mikrofon nicht verfügbar — gib deine Antwort lieber ein',
    micDenied: 'Das Mikrofon ist nicht verfügbar, weil Sie den Zugriff verweigert haben. Öffnen Sie die App erneut oder nutzen Sie die Tastatur',
    micSilent: 'Das Mikrofon hat nur Stille aufgenommen — versuch es noch mal',
    micStartFailed: 'Aufnahme konnte nicht gestartet werden — tippe noch mal ({{reason}})',
    backToVoice: 'Zurück zur Spracheingabe',
    typePlaceholder_en: 'Schreibe deine Antwort auf Englisch',
    typePlaceholder_de: 'Schreibe deine Antwort auf Deutsch',
    typePlaceholder_pt: 'Schreibe deine Antwort auf Portugiesisch',
    yourMessage: 'Deine Nachricht',
    send: 'Senden',
    typeText: 'Lieber tippen',
    deleteRecording: 'Aufnahme löschen',
    thinking: 'Denke nach',
    turnFailed: 'Ich konnte nicht antworten — versuch es noch mal',
    turnOffline: 'Keine Verbindung — prüf dein Internet und versuch es noch mal',
  },
  pt: {
    notFoundTitle: 'Conversa não encontrada',
    notFoundMessage: 'Este link leva a uma conversa de outra pessoa, ou ela foi excluída.',
    back: 'Voltar',
    closedMessage: 'Tente novamente mais tarde.',
    writeSupport: 'Falar com o suporte',
    preparingTutor: 'Preparando seu tutor',
    micUnavailable: 'Microfone indisponível — digite sua resposta',
    micDenied: 'O microfone está indisponível porque você negou o acesso a ele. Abra o app novamente ou use o teclado',
    micSilent: 'O microfone gravou só silêncio — tente de novo',
    micStartFailed: 'Não foi possível iniciar a gravação — toque de novo ({{reason}})',
    backToVoice: 'Voltar para a voz',
    typePlaceholder_en: 'Escreva sua resposta em inglês',
    typePlaceholder_de: 'Escreva sua resposta em alemão',
    typePlaceholder_pt: 'Escreva sua resposta em português',
    yourMessage: 'Sua mensagem',
    send: 'Enviar',
    typeText: 'Prefiro digitar',
    deleteRecording: 'Excluir gravação',
    thinking: 'Pensando',
    turnFailed: 'Não consegui responder — tente de novo',
    turnOffline: 'Sem conexão — verifique a internet e tente de novo',
  },
  fr: {
    notFoundTitle: 'Conversation introuvable',
    notFoundMessage: 'Ce lien mène à la conversation de quelqu’un d’autre, ou elle a été supprimée.',
    back: 'Retour',
    closedMessage: 'Réessaie plus tard.',
    writeSupport: 'Contacter le support',
    preparingTutor: 'On prépare ton tuteur',
    micUnavailable: 'Micro indisponible — écris ta réponse à la place',
    micDenied: 'Le micro est indisponible, car vous en avez refusé l’accès. Rouvrez l’app ou utilisez le clavier',
    micSilent: 'Le micro n’a enregistré que du silence — réessaie',
    micStartFailed: 'Impossible de démarrer l’enregistrement — réessaie ({{reason}})',
    backToVoice: 'Retour à la voix',
    typePlaceholder_en: 'Écris ta réponse en anglais',
    typePlaceholder_de: 'Écris ta réponse en allemand',
    typePlaceholder_pt: 'Écris ta réponse en portugais',
    yourMessage: 'Ton message',
    send: 'Envoyer',
    typeText: 'Écrire à la place',
    deleteRecording: 'Supprimer l’enregistrement',
    thinking: 'Je réfléchis',
    turnFailed: 'Je n’ai pas pu répondre — réessaie',
    turnOffline: 'Pas de connexion — vérifie ta connexion internet et réessaie',
  },
  es: {
    notFoundTitle: 'Conversación no encontrada',
    notFoundMessage: 'Este enlace lleva a la conversación de otra persona, o fue eliminada.',
    back: 'Volver',
    closedMessage: 'Inténtalo de nuevo más tarde.',
    writeSupport: 'Contactar con soporte',
    preparingTutor: 'Preparando tu tutor',
    micUnavailable: 'Micrófono no disponible — escribe tu respuesta',
    micDenied: 'El micrófono no está disponible porque denegaste el acceso. Vuelve a entrar o usa el teclado',
    micSilent: 'El micrófono grabó solo silencio — inténtalo de nuevo',
    micStartFailed: 'No se pudo iniciar la grabación — toca de nuevo ({{reason}})',
    backToVoice: 'Volver a la voz',
    typePlaceholder_en: 'Escribe tu respuesta en inglés',
    typePlaceholder_de: 'Escribe tu respuesta en alemán',
    typePlaceholder_pt: 'Escribe tu respuesta en portugués',
    yourMessage: 'Tu mensaje',
    send: 'Enviar',
    typeText: 'Prefiero escribir',
    deleteRecording: 'Eliminar grabación',
    thinking: 'Pensando',
    turnFailed: 'No pude responder — inténtalo de nuevo',
    turnOffline: 'Sin conexión — revisa tu internet e inténtalo de nuevo',
  },
};
